export const Console = (arg) => console.log(arg);